import axios from "axios";

const API_ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT}/lamf/api/v1`;
const AUTHORIZATION = process.env.REACT_APP_AUTHORIZATION;
const getAuthToken = () => {
    return localStorage.getItem('authToken');
  };

  export const fetchUserDetails = () => {
    const token = getAuthToken();
    const url = `${API_ENDPOINT}/get-user-details`; 
  
    let config = {
      headers: {
        Authorization: AUTHORIZATION,
        Authentication: token,
        "Content-Type": "application/json",
      },
      
    };
  
    
    
    return new Promise((resolve, reject) => {
        
      axios
        .get(url, config)
        .then((res) => {
          resolve(res.data);  
        })
        .catch((err) => {
          reject(err); 
        });
    });
  };
  


  export const generateLead = (leadData) => {
    const token = getAuthToken();
    const url = `${API_ENDPOINT}/generate-lead`;
  
    const queryParams = new URLSearchParams(leadData).toString();
    const fullUrl = `${url}?${queryParams}`;
  
    let config = {
      headers: {
        Authorization: AUTHORIZATION,
        Authentication: token,
      },
    };
  
    return new Promise((resolve, reject) => {
      axios
        .get(fullUrl, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  

  
  export const sendOtp = (userData) => {
    console.log(userData, "userdata1");
    
    const token = getAuthToken();
    const url = `${API_ENDPOINT}/send-otp`;
  
    const config = {
      headers: {
        Authorization: AUTHORIZATION, 
        Authentication: token, 
        "Content-Type": "application/json",
      },
    };
  
    const data = {
      user_id: userData.user_id,  
      name: userData.name,       
      email: userData.email,      
      pan: userData.pan,          
      phone_number: userData.phone_number, 
      dob: userData.dob,
      consent_given : userData.consent_given,     
    };
  
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
            
            
          resolve(res.data);  
        })
        .catch((err) => {
          reject(err);  
        });
    });
  };


  export const verifyOtpData = () => {
    const token = getAuthToken();
    const url = `${API_ENDPOINT}/verify-otp-data`; 
  
    const config = {
      headers: {
        Authorization: AUTHORIZATION,
        Authentication: token,
        "Content-Type": "application/json",
      },
    };
  
    return new Promise((resolve, reject) => {
      axios
        .get(url, config) 
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  

  
  export const verifyOtp = (otpData) => {
    const token = getAuthToken();
    const url = `${API_ENDPOINT}/verify-otp`;
  
    const config = {
      headers: {
        Authorization: AUTHORIZATION, 
        Authentication: token,       
        "Content-Type": "application/json",
      },
    };
  
    const data = {
      otp: otpData.otp, 
    };
  
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          resolve(res.data); 
        })
        .catch((err) => {
          reject(err); 
        });
    });
  };





export const notifyVisitorEvent = (payload) => {
  const url = "https://api.paymeindia.in/api/notify/event_send/";
  const token = getAuthToken();
  const config = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    },
  };

  return new Promise((resolve, reject) => {
    axios
      .post(url, payload, config)
      .then((response) => {
        console.log("Event successfully sent:", response);
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          console.error("API Error:", error.response.status, error.response.data);
          reject(error.response);
        } else if (error.request) {
          console.error("No response received:", error.request);
          reject(error.request);
        } else {
          console.error("Error in setup:", error.message);
          reject(error.message);
        }
      });
  });
};
